import Model, { attr, belongsTo } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import { camelize } from '@ember/string';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class AirbnbOfficialOpportunityInputFieldModel extends Model {
  @attr('string') key!: string;
  @attr('string') keyLabel!: string | null;

  @attr('string') value?: string;

  @cached
  get storageKey(): string {
    return camelize(this.key);
  }

  @belongsTo('airbnb-official-opportunity-value-constraint', {
    inverse: null,
    async: false,
  })
  airbnbOfficialOpportunityValueConstraint!: ModelRegistry['airbnb-official-opportunity-value-constraint'];

  @cached
  get constraint(): ModelRegistry['airbnb-official-opportunity-value-constraint'] {
    return this.airbnbOfficialOpportunityValueConstraint;
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'airbnb-official-opportunity-input-field': AirbnbOfficialOpportunityInputFieldModel;
  }
}
